import { CircleIcon, PrimaryButton, ReactIcons } from "@kalyzee/kalyzee-ui";
import clsx from "clsx";
import React, { useRef } from "react";
import { ScreenShareStatus } from "../../hooks/screenShare";
import OverlayInformationMessage from "../utils/OverlayInformationMessage";
import styles from "./button.module.css";

export const ScreenShareButton = React.memo(({ status, onToggle }: { status: ScreenShareStatus; onToggle: () => void }) => {
  const currRef = useRef<HTMLDivElement>(null);
  const ongoing = status === "ongoing";

  return (
    <div ref={currRef}>
      <PrimaryButton onClick={onToggle}>
        <CircleIcon
          icon={<ReactIcons.ScreenShare />}
          className={clsx(styles.button, ongoing && styles.active, status === "starting" && styles.starting)}
        />
      </PrimaryButton>
      <OverlayInformationMessage
        targetRef={currRef}
        message={ongoing ? "Arrêter le partage d'écran" : "Partager votre écran"}
      />
    </div>
  );
});
